/*
 *  I04CALCULGDETAItemI18n.js
 *
 *  Created by Sébastien Hecart on 2019-05-14 19:22:59 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I04CALCULGDETAItem_SECTION_0_TITLE: '',
  I04CALCULGDETAItem_in_namePart: 'Nom',
  I04CALCULGDETAItem_SECTION_00_TITLE: 'Paroi',
  I04CALCULGDETAItem_SECTION_1_TITLE: 'Matériau lourd',
  I04CALCULGDETAItem_m_lourd_nature: '',
  I04CALCULGDETAItem_in_m_lourd_epaisseur: 'Epaisseur',
  I04CALCULGDETAItem_SECTION_2_TITLE: 'Orientation',
  I04CALCULGDETAItem_res_vitrage_orientation: 'Orientation',
  I04CALCULGDETAItem_SECTION_3_TITLE: 'Type',
  I04CALCULGDETAItem_vitrage_uuid: '',
  I04CALCULGDETAItem_SECTION_4_TITLE: 'Isolant',
  I04CALCULGDETAItem_iso_nature: '',
  I04CALCULGDETAItem_in_iso_epaisseur: 'Epaisseur',
  I04CALCULGDETAItem_in_iso_position: 'Position',
  I04CALCULGDETAItem_in_iso_position_0: 'Extérieur',
  I04CALCULGDETAItem_in_iso_position_1: 'Intérieur',
  I04CALCULGDETAItem_in_iso_position_2: 'Sans',
  I04CALCULGDETAItem_SECTION_5_TITLE: 'Position paroi',
  I04CALCULGDETAItem_in_paroi_position: 'Position',
  I04CALCULGDETAItem_in_paroi_position_0: 'Extérieur',
  I04CALCULGDETAItem_in_paroi_position_1: 'Local non.chauf',
  I04CALCULGDETAItem_in_paroi_position_2: 'Véranda',
  I04CALCULGDETAItem_SECTION_6_TITLE: 'Valeur du U',
  I04CALCULGDETAItem_res_ucalc: 'Valeur du U',
  I04CALCULGDETAItem_in_ucorr: 'U corrigé',
  I04CALCULGDETAItem_SECTION_7_TITLE: 'Surface',
  I04CALCULGDETAItem_in_superficie: 'Superficie',
  I04CALCULGDETAItem_SECTION_8_TITLE: 'Orientation',
  I04CALCULGDETAItem_SECTION_9_TITLE: 'Position',
  I04CALCULGDETAItem_SECTION_10_TITLE: 'Position',
  I04CALCULGDETAItem_orientation_uuid: '',
  I04CALCULGDETAItem_title_facades: 'Façade',
  I04CALCULGDETAItem_title_plafonds: 'Plafond',
  I04CALCULGDETAItem_title_vitrages: 'Vitrage',
  I04CALCULGDETAItem_title_portes: 'Porte',
  I04CALCULGDETAItem_title_planchers: 'Plancher',
  I04CALCULGDETAItem_delete_alert: 'La suppression de cette façade supprimera aussi les vitrages associés à cette façade',
  I04CALCULGDETAItem_mail_position_isolant: "Position de l'isolant",
  I04CALCULGDETAItem_mail_natyre_ioslant: "Nature de l'isolant",
  I04CALCULGDETAItem_mail_ep_isolant: "Epaisseur de l'isolant",
  I04CALCULGDETAItem_mail_SECTION_9_TITLE: 'Position du plancher',
  I04CALCULGDETAItem_mail_SECTION_10_TITLE: 'Position du plafond'
}
